import React from "react";

import { Route, Switch, Redirect, useRouteMatch } from "react-router-dom";

import { NotificationsRoutes } from "./Constants/routes";

const Notifications = () => {
  const match = useRouteMatch();
  return (
    <>
      <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/all`} />
        {NotificationsRoutes.map(({ path, Component, exact, id }) => (
          <Route
            path={`${match.url}${path}`}
            exact={exact}
            component={Component}
            key={id}
          />
        ))}
        <Redirect to="/dashboard/notifications" />
      </Switch>
    </>
  );
};

export default Notifications;

